export default "__VITE_ASSET__DwDgwr1x__"